import Text from 'components/_UI/Text';
import { convertNeSwToNwSe } from 'google-map-react'
import React from 'react'
import { Column } from 'styled/alignment/Column';
import colors from 'theme/colors';
import GeneralTransactions from './GeneralTransactions';
import styled from 'styled-components';
import { Row } from 'styled/alignment/Row';
import GeneralWithdraws from './GeneralWithdraws';
import { Eye } from 'react-feather';
import breakpoints from 'theme/breakpoints';

export default function GeneralView({ statementBalance, withdraw, onStatementBalanceSeeAllClick, onSeeAllWithdrawClick }) {
    return (
        <Container>
            <CardContainer>
                <TitleHeader>
                    <Text name='subtitle' type='bold' color={colors.nightDark}>                        Transações recentes
                    </Text>

                    {
                        statementBalance?.length > 0 && (
                            <SeeAll onClick={onStatementBalanceSeeAllClick}>
                                <Eye size={16} />
                                <Text paddingBottom={0} marginLeft={'4px'} color={colors.nightDark} >Ver todas</Text>
                            </SeeAll>
                        )
                    }
                </TitleHeader>

                <GeneralTransactions data={statementBalance} />

            </CardContainer>

            <CardContainer>
                <TitleHeader>
                    <Column width={'auto'}>
                        <Text name='subtitle' type='bold' color={colors.nightDark} paddingBottom={'4px'}>
                            Histórico de saques
                        </Text>
                        <Text>
                            Acompanhe seus saques realizados
                        </Text>
                    </Column>
                    {
                        withdraw?.length > 0 && (
                            <SeeAll onClick={onSeeAllWithdrawClick}>
                                <Eye size={16} />
                                <Text paddingBottom={0} marginLeft={'4px'} color={colors.nightDark} >Ver todas</Text>
                            </SeeAll>
                        )
                    }
                </TitleHeader>

                <GeneralWithdraws withdraw={withdraw} />
            </CardContainer>
        </Container>
    )
}


const Container = styled(Column)`
    margin-top: 30px;

    @media screen and (min-width: ${breakpoints.lg}) {
        flex-direction: row;
        justify-content: space-between;
    }

`;
const CardContainer = styled(Column)`
    background-color: ${colors.neutralLight};
    /* border: 1px solid ${colors.nightLight}; */
    padding: 14px;
    border-radius: 6px;
    box-shadow: 0 0 4px #eee;
    margin-bottom: 15px;

    @media screen and (min-width: ${breakpoints.lg}) {
        &:first-child{
            margin-right: 1%;
            margin-bottom: 0;
        }
    }
    
`;

const SeeAll = styled(Row)`
    width: auto;
    align-items: center;
    cursor: pointer;
    transition: ease-in-out .25s all;
    padding: 4px 10px;
    border-radius: 6px;

    &:hover {
        opacity: 0.8;
        background-color: #F3E8FF;
    }
`;

const TitleHeader = styled(Row)`
    justify-content: space-between;
`;